import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../components/PageTitle";
import Index from "../view/MagicLogin/Index";
import { getCookie, getSlugByLang } from "../common/Helper";
import { useNavigate, useParams } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import { setEmailVerified, setLogin, setLogout, set2faVerified } from "../redux/user/user.action";
import ToastAlert from "../common/ToastAlert";
import { useEffect } from "react";
import { setBookunWebhook } from "../redux/global/global.action";


export default function MagicLoginController() {
    const user = useSelector((state) => state.user);
    const perems = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const logout = async () => {
        dispatch(setLogout())
        const logout = await ApiCall('post', 'logout', null, user?.token)
        if (logout) {
            if (logout.data?.success) {
                dispatch(setLogout())
                navigate( '/login')

            } else {
                dispatch(setLogout())
                navigate( '/login')

            }
        } else {
            ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
        }
    }

    const verifyMagicToken = async (token) => {
        const checkStatus = await ApiCall('post', 'supplier-impersonate-login', { token: token })
        if (checkStatus) {
            if (checkStatus?.data?.success) {
                let dispatchData = {}
                dispatchData.userDetails = checkStatus.data.user
                dispatchData.token = checkStatus.data.access_token
                dispatchData.tempEmail = checkStatus.data.user.email
                dispatchData.supplierDetails = checkStatus.data.supplier
                dispatchData.is2faEnabled = checkStatus.data.user?.is_2fa_enabled
                dispatchData.permissions = checkStatus.data.user?.permissions
                dispatchData.isWelcomePageEnabled = checkStatus.data?.is_welcome_page_enabled;
                dispatch(setLogin(dispatchData))
                dispatch(setBookunWebhook(checkStatus.data?.isBokunWebhookSetup));
                dispatch(setEmailVerified(true))
                // Only when the supplier actually has 2FA enabled: admin impersonation
                // is already authenticated and can't supply their OTP, so mark 2FA as
                // verified to bypass the gate. Suppliers without 2FA are left untouched.
                if (checkStatus.data.user?.is_2fa_enabled) {
                    dispatch(set2faVerified(true))
                }
                ToastAlert({ msg: checkStatus.data.message, msgType: 'success' });

                const isWelcomePageEnabled = checkStatus.data?.is_welcome_page_enabled;
                const redirectTo = isWelcomePageEnabled ? "/information" : "/dashboard";

                navigate(redirectTo)
            } else {
                logout()
                ToastAlert({ msg: checkStatus.data.message, msgType: 'error' });
            }
        }
    };


    useEffect(() => {
        (async () => {
            if (perems.token && getCookie("is_admin_logged_in")) {
                await verifyMagicToken(perems.token)
            } else {
                navigate('/')
            }
        })();
    }, [perems.token, getCookie("is_admin_logged_in")]);


    return (
        <>
            <PageTitle title={'Authenticate'} />
            <Index  />
        </>
    )

}